import CommentIcon from '@mui/icons-material/Comment';
import Modal, { ModalTypes } from '@/trio-ui/Modal';
import UserInitials from '@/trio-ui/UserInitials';
import { PersonType } from '@/types/api';

type Props = Pick<ModalTypes, 'isOpen' | 'onClose'> & {
  answer: string;
  manager?: PersonType;
};

const PTOAnswerViewerModal = ({ answer, manager, ...modalProps }: Props): JSX.Element => {
  const Body = (
    <>
      <div className="tw-p-3 tw-rounded tw-border tw-border-neutral-40 elevation-centered-1 tw-shadow-elevation-centered-1 tw-text-sm tw-leading-normal tw-text-neutral-90">
        {answer}
      </div>
      {manager && (
        <div className="tw-flex tw-items-start tw-mt-4 tw-gap-3">
          <p className="tw-text-black tw-text-sm tw-leading-normal">Answered by</p>
          <div className="tw-flex tw-items-center">
            <UserInitials
              firstName={manager.firstName}
              lastName={manager.lastName}
              pictureUrl={manager.pictureUrl || undefined}
              size={24}
              className="!tw-mr-2"
            />
            <p className="tw-text-black tw-text-sm tw-leading-normal tw-font-semibold">
              {manager.firstName} {manager.lastName}
            </p>
          </div>
        </div>
      )}
    </>
  );

  return (
    <Modal
      headerIcon={CommentIcon}
      modalTitle="Manager’s Answer Note"
      {...modalProps}
      bodyRender={Body}
      onCancelLabel="Close"
      isCentered
    />
  );
};

export default PTOAnswerViewerModal;
